/* eslint-disable valid-typeof */
import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';

export interface PlacesFilter {
  placeId?: string;
}

export type PlacesDetailsResponse = {
  city: string[];
  postcode: string[];
  countryCode: string;
};

export type PlacesDetailsErrorResponse = {
  error: {
    data: {
      reason: string;
    };
  };
};

export default function usePlaceDetails(
  filter: PlacesFilter,
  onSuccess: (data: PlacesDetailsResponse) => void,
  errorOnUnsafeLicense = false,
) {
  const jwt = useJwt();
  let lang = 'FR';
  if (typeof window !== undefined) {
    lang = window.config?.LANGUAGE ?? 'FR';
  }

  return useQuery<PlacesDetailsResponse, Error>(
    ['places/details', { ...filter, lang, jwt, errorOnUnsafeLicense }],
    {
      enabled: (filter.placeId?.length ?? 0) > 0,
      onSuccess,
    },
  );
}
